"use client";
import React from "react";
import { SnackbarProvider } from "notistack";

const NotiStackProvider = ({ children }) => {
  return <SnackbarProvider>{children}</SnackbarProvider>;
};

export default NotiStackProvider;
